import classes from './Channels.module.scss';
import BadgeList from '../../molecules/badgeList/BadgeList';
import ChannelsCarousel from '../../organisms/channelsCarousel/ChannelsCarousel';
import featuresSettings from './config/carouselSettings.json';

export default function Channels(props) {
    if (!props) return null;

    const { channel_features, channel_carousel, section_title, tags_title } = props[0];

    return (
        <div className={classes.oChannels}>
            <div className={`${classes.oContainer} container`}>
                <div className={`row`}>
                    <div className={`${classes.oBodyBlock} col-12 col-md-6`}>
                        <div className={`${classes.blockWrapper} fontRTL`}>
                            <h3 className={`${classes.aTitle} fnt30f`}>
                                {section_title.site_header}
                            </h3>
                            <div className={`${classes.aText} fnt18f fnt-pm`}>
                                <p>{section_title.site_description}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={classes.carouselWrapper}>
                    <ChannelsCarousel config={featuresSettings} content={channel_carousel} />
                </div>
                <div className={`row`}>
                    <div className={`${classes.oFeatures} col-12`}>
                        <div className={classes.oBadgeWrapper}>
                            <BadgeList title={tags_title} data={channel_features} />
                        </div>
                    </div>
                </div>
            </div>
            <figure className={classes.oBackground}>
                <svg
                    width="702"
                    height="750"
                    viewBox="0 0 702 750"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={classes.aSvgDesk}
                >
                    <path
                        d="M416.853 743.481C550.427 767.202 760.061 721.353 794.499 683.544L838 114.855C812.366 120.553 734.375 123.867 627.487 91.5484C493.877 51.1498 253.068 -78.592 82.1711 68.2415C-88.7254 215.075 55.7598 425.614 82.1711 546.033C108.582 666.452 217.659 708.107 416.853 743.481Z"
                        fill="url(#paint0_linear_829_6964)"
                        fillOpacity="0.6"
                    />
                    <defs>
                        <linearGradient
                            id="paint0_linear_829_6964"
                            x1="41.9999"
                            y1="72"
                            x2="512.5"
                            y2="542.5"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stopColor="#ADFEFF" />
                            <stop offset="0.779675" stopColor="#21E9D1" />
                        </linearGradient>
                    </defs>
                </svg>
            </figure>
        </div>
    );
}
